import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { FaRegHandPointRight } from "react-icons/fa";
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { CgChanel } from 'react-icons/cg'
import { addDataAPI, fetchAllDataAPI } from '../../utils/api';
import ContentWrapper from '../../components/contentwrapper/ContentWrapper';


const AddDeliveryStatus = () => {
    const navigate = useNavigate();
    const [values, setUserValue] = useState({});
    const [validated, setValidated] = useState(false);
    const [courier, setCourier] = useState([]);

    const subadminid = localStorage.getItem('subadmindata');

    useEffect(() => {
        if (subadminid) {
            navigate('/add-subadmin-delivery-status');
            getAllCourierPatner()
        }
        else {
            navigate("/");
        }
    }, [subadminid]);

    const getAllCourierPatner = () => {
        fetchAllDataAPI('sub-admin-get-active-courier-data').then((res) => {
            if (res.data.status === 1) {
                setCourier(...[res.data.courierdata])
            }
        })
    }
    const handleInputs = async (e) => {
        setUserValue({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    const handleAddChanel = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            const datavalue = {
                couriername: values?.couriername,
                dstatus_name: values?.dstatus_name,
                delivery_status_code: values?.delivery_status_code,
                subadmin_id: subadminid,
            };
            addDataAPI('sub-admin-add-delivery-status', datavalue).then((res) => {
                if (res.data.status === 1) {
                    navigate("/all-subadmin-delivery-status");
                    toast.success("Delivery Status has been added successfully!!")
                }
                else if (res.data.status === 2) {
                    toast.warning("Delivery Status already Exit!!")
                }
                else {
                    toast.warning("Check your connection!!");
                }
            })
        }
        setValidated(true);
    }
    return (
        <div className="addCompany">
            <Helmet>
                <title>SATKARTAR:SUB ADMIN::ADD DELIVERY STATUS</title>
            </Helmet>

            <ContentWrapper>
                <div className="col-xl-6">
                    <div className="card border-top border-0 border-4 border-danger">
                        <div className="card-body formbody">
                            <div className="card-title d-flex align-items-center">
                                <div>
                                    <CgChanel className="formIcons" />
                                </div>
                                <h5 className="mb-0 text-danger">ADD Delivery Status</h5>
                            </div>
                            <hr />
                            <Form noValidate validated={validated} method="POST" onSubmit={handleAddChanel}>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="12" controlId="validationCustom04">
                                        <Form.Label>Select Courier</Form.Label>
                                        <Form.Select
                                            required
                                            placeholder="Gender Name"
                                            name="couriername"
                                            onChange={handleInputs}>
                                            <option value="">Select Courier</option>
                                            {courier?.map((courier, index) => (
                                                <option key={index} value={courier?.courier_name}>{courier?.courier_name}</option>
                                            ))}

                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            <FaRegHandPointRight /> Please provide a call type
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} md="12" controlId="validationStatusName">
                                        <Form.Label>Delivery Status Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Delivery Status Name"
                                            aria-describedby="inputGroupPrepend"
                                            required
                                            name="dstatus_name"
                                            onChange={handleInputs}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            <FaRegHandPointRight /> Please provide a valid status name.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} md="12" controlId="validationStatusCode">
                                        <Form.Label>Status Code</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Status Code"
                                            aria-describedby="inputGroupPrepend"
                                            required
                                            name="delivery_status_code"
                                            onChange={handleInputs}
                                            pattern="[0-9]*"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            <FaRegHandPointRight /> Please provide a valid status code.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                <Button type="submit">Add</Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default AddDeliveryStatus